var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormulateInput',{attrs:{"label-text":"Поток*","type":"CustomSearchSelect","name":"formulate_product_id","options":_vm.productsList,"placeholder":"Выберите значение","validation":"required","validation-messages":{
		'required': 'выберите значение',
	}},on:{"search":function($event){return _vm.getProducts($event)}},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})
}
var staticRenderFns = []

export { render, staticRenderFns }